import React from 'react';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
	const user = JSON.parse(localStorage.getItem('user'));

	if (!user || !user.id) {
		return <Navigate to="/" />;
	}

	return children;
}
